__turbopack_context__.v({
  "partner": "sMVxXa_partner",
  "partnerGrid": "sMVxXa_partnerGrid",
  "partnerLogo": "sMVxXa_partnerLogo",
});
